<app-user-select *ngIf="this.adminMode && !adminPostUserSelected"
                 (userSelected)="adminPostUser=$event"></app-user-select>
<label *ngIf="adminMode && adminPostUserSelected">{{adminPostUserSelected.displayNameString}}</label>
<app-post-form *ngIf="!this.adminMode || adminPostUserSelected" [entityForm]="form" [formState]="formState"
               (onNextStep)="nextStep()" (onFormCompleted)="registerForm($event)"></app-post-form>
<div class="actions">
  <button *ngIf="this.adminMode && adminPostUser && !adminPostUserSelected" mat-flat-button color="primary"
          (click)="adminPostUserSelected = adminPostUser">
    <div class="button__container">
      <span>Choisir</span>
      <mat-icon aria-hidden="previous" aria-label="prev" svgIcon="user-plus"></mat-icon>
    </div>
  </button>
  <button *ngIf="this.formState?.showPrev" mat-flat-button color="primary" (click)="prevStep()">
    <div class="button__container">
      <span>{{"crud.actions.prev" | translate }}</span>
      <mat-icon aria-hidden="previous" aria-label="prev" svgIcon="chevron-left"></mat-icon>
    </div>
  </button>
  <button *ngIf="this.formState?.showNext" mat-flat-button color="primary" (click)="nextStep()">
    <div class="button__container">
      <span>{{"crud.actions.next" | translate }}</span>
      <mat-icon aria-hidden="next" aria-label="next" svgIcon="chevron-right"></mat-icon>
    </div>
  </button>
  <button *ngIf="this.formState?.showSaveDraft" mat-flat-button (click)="saveDraft()">
    <div class="button__container">
      <span>{{"crud.actions.save_draft" | translate }}</span>
      <mat-icon aria-hidden="previous" aria-label="prev" svgIcon="device-floppy"></mat-icon>
    </div>
  </button>
  <button *ngIf="this.formState?.finished" mat-flat-button color="primary" (click)="publish()" [disabled]="!form.valid">
    <div class="button__container">
      <span>{{"crud.actions.create" | translate }}</span>
      <mat-icon aria-hidden="previous" aria-label="prev" svgIcon="check"></mat-icon>
    </div>
  </button>
</div>
<p-messages [(value)]="messages"></p-messages>
